export const SEMAPHORE = {
  verde: { label: "Verde · avanzado", dot: "bg-emerald-500", soft: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border-emerald-500/40" },
  amarillo: { label: "Amarillo · en proceso", dot: "bg-amber-500", soft: "bg-amber-500/15 text-amber-700 dark:text-amber-400 border-amber-500/40" },
  rojo: { label: "Rojo · especulativo", dot: "bg-red-600", soft: "bg-red-500/15 text-red-700 dark:text-red-400 border-red-500/40" },
};
const SEM_OPTS = { verde: "Verde", amarillo: "Amarillo", rojo: "Rojo" };
const CUR_OPTS = { MXN: "MXN", USD: "USD", EUR: "EUR" };
export const OPP_TYPES = { otro_negocio: "Otro negocio", del_despacho: "Del despacho (SIGMAAT)" };
export const MEDIUMS = { llamada: "Llamada", reunion: "Reunión", comida: "Comida", desayuno: "Desayuno", whatsapp: "WhatsApp", correo: "Correo", otro: "Otro" };
export const PAY_METHODS = { transferencia: "Transferencia", efectivo: "Efectivo", cheque: "Cheque", otro: "Otro" };
export const COMMISSION_STATUS_ORDER = ["pactada_verbal", "confirmada_por_escrito", "por_cobrar", "cobrada", "cancelada"];

export const CONTACT_FIELDS = [
  { key: "name", label: "Nombre", type: "text", required: true },
  { key: "nickname", label: "Apodo", type: "text" },
  { key: "company", label: "Empresa", type: "text" },
  { key: "position", label: "Cargo", type: "text" },
  { key: "phone", label: "Teléfono", type: "tel" },
  { key: "whatsapp", label: "WhatsApp", type: "tel" },
  { key: "email", label: "Correo", type: "email" },
  { key: "city", label: "Ciudad", type: "text" },
  { key: "relationship_type", label: "Tipo de relación", type: "select", catalog: "relationship_types" },
  { key: "introduced_by_id", label: "Quién me lo presentó", type: "contact" },
  { key: "whatsapp_group", label: "Grupo de WhatsApp", type: "text" },
  { key: "specialties", label: "Especialidades", type: "tags", catalog: "specialties" },
  { key: "sectors", label: "Sectores", type: "tags", catalog: "sectors" },
  { key: "reach", label: "Alcance (a quién llega)", type: "tags" },
  { key: "usual_commission_terms", label: "Términos habituales de comisión", type: "text" },
  { key: "profile_text", label: "Perfil: qué hace y qué trae", type: "textarea" },
  { key: "notes", label: "Notas", type: "textarea" },
  { key: "is_private_only_me", label: "Privacidad", type: "bool", ownerOnly: true, hint: "Solo yo (invisible para el asistente)" },
];

export const OPP_FIELDS = [
  { key: "title", label: "Título", type: "text", required: true },
  { key: "description", label: "Descripción", type: "textarea" },
  { key: "requester_id", label: "Quien pide (origen)", type: "contact" },
  { key: "resolver_id", label: "Quien resuelve (destino)", type: "contact" },
  { key: "participant_ids", label: "Otros participantes", type: "contacts" },
  { key: "type", label: "Tipo", type: "select", options: OPP_TYPES },
  { key: "stage", label: "Etapa", type: "select", catalog: "stages" },
  { key: "semaphore", label: "Semáforo", type: "select", options: SEM_OPTS },
  { key: "potential_amount", label: "Potencial (monto)", type: "money", currencyKey: "potential_currency" },
  { key: "potential_currency", label: "Moneda del potencial", type: "select", options: CUR_OPTS },
  { key: "potential_confidence", label: "Confianza", type: "select", options: { alta: "Alta", media: "Media", baja: "Baja" } },
  { key: "next_step_text", label: "Próximo paso", type: "text" },
  { key: "next_step_date", label: "Fecha del próximo paso", type: "date" },
  { key: "last_contact_date", label: "Último contacto (fecha)", type: "date" },
  { key: "last_contact_contact_id", label: "Último contacto (con quién)", type: "contact" },
  { key: "last_contact_medium", label: "Último contacto (medio)", type: "select", options: MEDIUMS },
  { key: "responsible_user_id", label: "Responsable", type: "user" },
  { key: "sectors", label: "Sectores", type: "tags", catalog: "sectors" },
  { key: "sigmaat_link", label: "Enlace SIGMAAT", type: "text" },
  { key: "resolver_collected_amount", label: "Monto cobrado por quien resuelve", type: "money", currencyKey: "resolver_collected_currency", ownerOnly: true },
  { key: "resolver_collected_currency", label: "Moneda de lo cobrado", type: "select", options: CUR_OPTS, ownerOnly: true },
  { key: "resolver_collected_date", label: "Fecha de lo cobrado", type: "date", ownerOnly: true },
  { key: "is_private_only_me", label: "Privacidad", type: "bool", ownerOnly: true, hint: "Solo yo (invisible para el asistente)" },
];

export const RESOLVER_FIELDS = OPP_FIELDS.filter((f) => f.key.startsWith("resolver_collected"));

export const COMMISSION_FIELDS = [
  { key: "modality", label: "Modalidad", type: "select", catalog: "commission_modalities", required: true },
  { key: "payer_contact_id", label: "Quién paga (contacto)", type: "contact" },
  { key: "payer_name", label: "Quién paga (texto, si no es contacto)", type: "text" },
  { key: "percentage", label: "% (honorario o recurrente)", type: "pct" },
  { key: "num_parts", label: "Número de partes (tercios)", type: "int" },
  { key: "specialist_cost", label: "Costo del especialista (tercios)", type: "money" },
  { key: "fixed_amount", label: "Monto fijo", type: "money" },
  { key: "base_description", label: "Base (sobre qué se calcula)", type: "text" },
  { key: "currency", label: "Moneda", type: "select", options: CUR_OPTS },
  { key: "status", label: "Estado", type: "select", catalog: "commission_statuses" },
  { key: "agreement_date", label: "Fecha del acuerdo", type: "date" },
  { key: "confirmed_in_writing", label: "Confirmación", type: "bool", hint: "Confirmado por escrito" },
  { key: "notes", label: "En qué quedamos", type: "textarea" },
];

export const waLink = (phone, text) => {
  const digits = (phone || "").replace(/\D/g, "");
  const num = digits.length === 10 ? `52${digits}` : digits;
  return `https://wa.me/${num}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};
